import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

/** Snapshot-based detail pages opt in to recreation when the record or workspace changes. */
@Injectable()
export class WorkspaceRecordReuseStrategy extends BaseRouteReuseStrategy {
    override shouldReuseRoute(future: ActivatedRouteSnapshot, current: ActivatedRouteSnapshot): boolean {
        if (!super.shouldReuseRoute(future, current)) return false;
        if (!future.routeConfig?.data?.['reloadOnRecordChange']) return true;
        const keys = new Set([...Object.keys(future.params), ...Object.keys(current.params)]);
        return [...keys].every(key => future.params[key] === current.params[key])
            && future.queryParamMap.get('workspaceTenantId') === current.queryParamMap.get('workspaceTenantId')
            && future.queryParamMap.get('tenantId') === current.queryParamMap.get('tenantId');
    }
}
